import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class TriggersTableHeader extends Component {

  static Layout = [
    { column: "commodityName", width: 2, name: "Commodity Name" },
    { column: "period", width: 2 },
    { column: "triggerPrice", name: "Trigger Price" },
    { column: "lastTradePrice", width: 2, name: "Last Trade" },
    { column: "lastNightsOfferPrice", width: 2, name: "Last Night's Close" }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={TriggersTableHeader.Layout}/>
    )
  }
}